import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Button, Col, Form, Input, message, notification, Row, Select } from 'antd';
import { addHighlights, editBookChapter, markBookChapterChecked, rewriteBookChapter, rewriteBookEpisode } from '../actions';
const { TextArea } = Input;
const { Option } = Select;
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from '../lib/db';

const mainPrompt = `You need to write a concise version of this text that is stimulating and engaging. To do so, first you must extract the key terms introduced in the text. Next, you must use it to write a good narrative. Preserve the anecdotes, research studies, inspiring stories. It should be engaging and conversational. 

            Begin!`;
const mainPrompt4o = `You need to write a concise version of this text that is stimulating and engaging. you must use it to write a good narrative. It should be engaging and conversational. Use simpler words and medium length sentences.

            Begin!`;

export default class EpisodeDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageX: 0, pageY: 0, showHighlightMenu: false, selectedTextVal: '',
            highlights: {}, fullUrl: '',
            displayType: 0,
            modelType: 'gpt-4o',
            description: props.description,
            insight: props.podcastEpisode.insight || '',
            thirdPersonPrompt: `Rewrite this in third person. Replace I with author name ABC`,
            prompt: props.podcastEpisode.title == 'Conclusion' ?

                `Summarise the main ideas in the following text and write a recap. Write as if they are personal insights without directly referencing the author or the text. Don't include the examples or anecdotes when writing this. Remember to keep it crisp.

                Begin!` : mainPrompt4o


        };
    }

    componentDidMount() {
        const { podcastEpisode } = this.props;
        const bookRef = ref(storage, `booksWhole/${podcastEpisode.collectionId}.json`);
        console.dir(bookRef);
        getDownloadURL(bookRef).then((url) => {
            console.dir(url);
            this.setState({ fullUrl: url });
        })


        if (!this.x) {
            this.x = {};
        }

        this.x.Selector = {};
        this.x.Selector.getSelected = function () {
            var t = '';
            if (window.getSelection) {
                t = window.getSelection();
            } else if (document.getSelection) {
                t = document.getSelection();
            } else if (document.selection) {
                t = document.selection.createRange().text;
            }
            return t;
        }

        // var pageX;
        // var pageY;
    }

    changeInsight = (e) => {
        this.setState({ insight: e.target.value });
    }
    changeDescription = (e) => {
        this.setState({ description: e.target.value });
    }
    changePrompt = (e) => {
        this.setState({ prompt: e.target.value });
    }
    changeThirdPersonPrompt = (e) => {
        this.setState({ thirdPersonPrompt: e.target.value });
    }
    save = () => {
        if (window.confirm("Are you sure?")) {
            const { description } = this.state;
            const { guid } = this.props;
            editBookChapter(guid, description).then(() => {
                message.success('Updated Content.');
            }).catch(err => {
                alert('There was an error saving. Contact suboo');
            })
            return;
        }
    }
    saveInsight = () => {
        if (window.confirm("Are you sure?")) {
            const { insight } = this.state;
            const { guid } = this.props;
            editBookChapter(guid, '', insight).catch(err => {
                alert('There was an error saving. Contact suboo');
            })
            return;
        }
    }
    markChecked = () => {
        if (window.confirm("Are you sure?")) {
            // const { description } = this.state;
            const { guid } = this.props;
            markBookChapterChecked(guid).catch(err => {
                alert('There was an error saving. Contact suboo');
            })
            return;
        }
    }
    rewrite = () => {
        if (window.confirm("Are you sure?")) {
            const { prompt, modelType } = this.state;
            const { podcastEpisode } = this.props;
            rewriteBookChapter(podcastEpisode.collectionId, podcastEpisode.pubDate, prompt, podcastEpisode.title, modelType)
                .then(() => {
                    alert(`Chapter ${podcastEpisode.pubDate} Done. Close and reopen the episode.`);
                })
                .catch(err => {
                    alert('There was an error saving. Contact suboo');
                })
            return;
        }
    }
    rewriteThirdPerson = () => {
        if (window.confirm("Are you sure?")) {
            const { thirdPersonPrompt, description } = this.state;
            // const { podcastEpisode } = this.props;
            rewriteBookEpisode(description, thirdPersonPrompt)
                .then((returnText) => {
                    // alert(`Chapter ${podcastEpisode.pubDate} Done. Close and reopen the episode.`);
                    this.setState({ description: returnText });
                })
                .catch(err => {
                    alert('There was an error saving. Contact suboo');
                })
            return;
        }
    }

    onMousedown = (e) => {
        this.pageX = e.pageX;
        this.pageY = e.pageY;
        console.dir(this.pageX);
        console.dir(this.pageY);
        this.setState({ pageX: e.pageX, pageY: e.pageY });
    }

    onMouseUp = (e) => {
        console.dir(e);
        var selectedText = this.x.Selector.getSelected();
        console.dir(window.getSelection());
        console.dir(window.getSelection().toString());
        console.dir(document.selection);
        console.dir(selectedText);
        if (selectedText != '') {
            var selection = window.getSelection();
            console.dir(selection);
            var start = selection.anchorOffset;
            var end = selection.focusOffset;
            if (start >= 0 && end >= 0) {
                console.log("start: " + start);
                console.log("end: " + end);
            }
            this.setState({ showHighlightMenu: true, selectedTextVal: window.getSelection().toString() });
            // $('ul.tools').css({
            //     'left': pageX + 5,
            //     'top': pageY - 55
            // }).fadeIn(200);
        } else {
            this.setState({ showHighlightMenu: false, selectedTextVal: '' });
            // $('ul.tools').fadeOut(200);
        }
    }

    highlightText = () => {
        const { podcastEpisode } = this.props;
        const { selectedTextVal, description, highlights } = this.state;
        // var selectedText = window.getSelection().toString();
        console.dir(selectedTextVal);
        const ind = description.indexOf(selectedTextVal);
        if (ind >= 0) {
            console.dir(ind);
            console.dir(ind + selectedTextVal.length);
            const start = ind;
            const end = ind + selectedTextVal.length;
            const timeNow = Date.now();
            const highlightsMap = {};
            highlightsMap[`${start}-${end}`] = timeNow;
            this.setState({ showHighlightMenu: false, selectedTextVal: '', highlights: { ...highlights, highlightsMap } });
            addHighlights(podcastEpisode.guid, podcastEpisode.collectionId, start, end);
        }
    }

    modelTypeChange = (e) => {
        console.dir(e);
        let prompt;
        if (e && e.includes('4o')) {
            prompt = mainPrompt4o;
        } else {
            prompt = mainPrompt;
        }
        this.setState({ modelType: e, prompt });
    }
    badWordCount = (description) => {
        const us = ((description).split(' us ').length - 1) + ((description).split(` us.`).length - 1);
        const our = ((description).split(' our ').length - 1) + ((description).split(' Our ').length - 1) +
            ((description).split(`\nOur `).length - 1);
        const we = ((description).split(' we ').length - 1) + ((description).split(' We ').length - 1) +
            ((description).split(`\nWe `).length - 1);
        return { us, our, we };
    }
    iCount = (description) => {
        return ((description).split('I ').length - 1) + ((description).split("I'").length - 1)
            - ((description).split('AI ').length - 1) - ((description).split('MRI ').length - 1);
        // return ((description).split("I'").length - 1);
    }
    meCount = (description) => {
        return ((description).split(' me ').length - 1) + ((description).split(" my ").length - 1);
        // return ((description).split("I'").length - 1);
    }

    switchDisplay = () => {
        const { displayType } = this.state;
        this.setState({ displayType: (displayType + 1) % 2 });
    }

    firstParaBig() {
        const { description } = this.state;
        const split = description.split('\n')[0];
        return split.length > 330;
    }

    copyWithoutLineBreak = async () => {
        const { description } = this.state;
        await navigator.clipboard.writeText(description.replaceAll('\n', ''));
        message.info('copied');
    }

    render() {
        const { description, prompt, thirdPersonPrompt, pageX, pageY, showHighlightMenu, fullUrl,
            highlights, modelType, insight, displayType } = this.state;
        const { podcastEpisode } = this.props;
        console.dir(displayType);
        const { us, our, we } = this.badWordCount(description || '');
        // console.dir(description);
        return (
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button type='primary' onClick={this.save}>Save</Button>
                    <Button type='' onClick={this.copyWithoutLineBreak}>Copy</Button>
                    <p>{(description || '').split(' ').length} words</p>
                    {/* <Button onClick={this.switchDisplay}>Switch</Button> */}
                    <p><a target='_blank' rel="noopener noreferrer" href={fullUrl}>Book url</a></p>
                    <p>&apos;I&apos; words - {this.iCount(description || '')}; &nbsp; me/my words - {this.meCount(description || '')}
                        &nbsp; us - {us}
                        &nbsp; our - {our}
                        &nbsp; we - {we}

                    </p>
                    <Button type='primary' disabled={podcastEpisode.manuallyChecked} onClick={this.markChecked}>Mark Checked</Button>
                </div>
                {this.firstParaBig() && <p style={{ color: 'red' }}>First para too big</p>}
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <TextArea placeholder="Description" value={description}
                        onChange={this.changeDescription}
                        onMouseDown={this.onMousedown}
                        onMouseUp={this.onMouseUp}
                        rows={20}
                    />
                    <div className='mob-view'><p dangerouslySetInnerHTML={{
                        __html: (description || '').replaceAll('\n', '<br />')
                            .replaceAll('[[', '<b>')
                            .replaceAll(']]', '</b>')
                    }} /></div>
                </div>
                <br />
                <br />
                {podcastEpisode.title != 'Conclusion' &&
                    <div>
                        <Button type='primary' onClick={this.saveInsight}>Save Insight</Button>
                        {(insight || '').startsWith('Th') && <p style={{ color: 'red' }}>Something wrong</p>}
                        <TextArea placeholder="Description" value={insight}
                            onChange={this.changeInsight}
                            rows={3}
                        />
                    </div>
                }
                <br />
                <br />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button type='primary' onClick={this.rewrite}>Rewrite</Button>
                    <Select defaultValue="all" style={{
                        width: 200, marginRight: '4px',
                        transform: 'translate(0px, -4px)'
                    }} value={modelType} onChange={this.modelTypeChange}>
                        <Option value="gpt-4-32k">gpt-4-32k</Option>
                        <Option value="gpt-35-turbo-16k">gpt-35-turbo-16k</Option>
                        <Option value="gpt-4">gpt-4</Option>
                        <Option value="gpt-4-1106-preview">gpt-4-1106-preview</Option>
                        <Option value="gpt-4o">gpt-4o</Option>
                        <Option value="gpt-4oo">gpt-4o-OPENAI</Option>
                    </Select>
                </div>
                <TextArea placeholder="" value={prompt}
                    onChange={this.changePrompt}
                    rows={6}
                />
                <br />
                <br />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button type='primary' onClick={this.rewriteThirdPerson}>Rewrite</Button>
                </div>
                <TextArea placeholder="" value={thirdPersonPrompt}
                    onChange={this.changeThirdPersonPrompt}
                    rows={6}
                />
                {/* <ul className="tools">
                    <li onClick={this.highlightText}>Highlight</li>
                </ul> */}
                <style jsx>
                    {`
                        .mob-view {
                            width: 360px;
                            margin: auto;
                            font-size: 1rem;
                            padding-top: 2em;
                            padding-left: 1em;
                            padding-right: 4px;
                            height: 500px;
                            overflow-y: auto;
                        }
                        ul.tools {
                            display: ${showHighlightMenu ? 'block' : 'none'};
                            list-style: none;
                            box-shadow: 0px 0px 4px rgba(0,0,0,.5);
                            border: solid 1px #000;
                            position: absolute;
                            background: #fff;
                            left: ${showHighlightMenu ? pageX + 5 : 0}px;
                            top: ${showHighlightMenu ? pageY - 55 : 0}px;
                        }
                        ul.tools li {
                            display: inline-block;
                            width: 40px;
                            height: 20px;
                            border: solid 1px #000;
                            margin: 5px;
                            padding: 5px 10px;
                            cursor: pointer;
                        }
                    `}
                </style>
            </div>
        )
    }
}

EpisodeDescription.propTypes = {
    description: PropTypes.string,
    guid: PropTypes.string,
    podcastEpisode: PropTypes.object,
    isCard: PropTypes.bool,
}
